export const checkIfUrlStartsWithTel = (url: string) => {
    return (url.indexOf('tel:') === 0);
}